// src/components/signup/SignupStep1.jsx
import React, { useState } from 'react';
import { auth, googleProvider } from '../../firebase';
import { createUserWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import GoogleSignInButton from '../google/googleButton';

export default function SignupStep1({ onComplete }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isStrongPassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return regex.test(password);
  };

  const [error, setError] = useState('');

  const handleEmailSignup = async (e) => {
    e.preventDefault();
  
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
  
    if (!isStrongPassword(password)) {
      setError('Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.');
      return;
    }
  
    setLoading(true);
    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
  
      const user = result.user;
      if (!user) {
        setError('Authentication failed to initialize. Please try again.');
        setLoading(false);
        return;
      }
  
      const token = await user.getIdToken(true); // 🔒 Ensure token is ready
  
      onComplete(user.uid, user.email, true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Create Account</h2>
      <form onSubmit={handleEmailSignup} className="grid gap-4 mb-6">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border p-2"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border p-2"
          required
        />

        {error && <div className="text-red-500 text-sm">{error}</div>}

        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
          Continue with Email
        </button>
      </form>

      <div className="text-center mb-2 text-gray-500">or</div>

        <GoogleSignInButton onComplete={onComplete} />
    </div>
  );
}